import { graphql, useStaticQuery } from 'gatsby'
import PropTypes from 'prop-types'
import React from 'react'

import { chainDecorators, memoized } from '../../utils/ReactUtils'
import { getTranslationFunction, Context } from '../../utils/TranslationUtils'
import router from '../../router/index'
import routes from '../../router/routes'


const decorators = [
  memoized,
]

function TranslationInjector(props) {
  const { locale, children } = props

  const data = useStaticQuery(graphql`
      query MyQuery {
          allContentfulLocale {
              edges {
                  node {
                      ...bbsContentfulTranslations
                  }
              }
          }
          allContentfulProject {
              edges {
                  node {
                      slug
                      title
                      node_locale
                  }
              }
          }
          allLocales {
              edges {
                  node {
                      code
                      name
                  }
              }
          }
      }
  `)

  const projects = data.allContentfulProject.edges

  const getProjectByPath = path => projects
    .map(({ node }) => node)
    .find(entry => (
      entry.node_locale === locale
      && router(routes.project.path, { slug: entry.slug, locale }) === path))

  const json = data.allContentfulLocale.edges
    .find(({ node }) => node.node_locale === locale)
    ?.node?.childContentfulLocaleTextsJsonNode?.internal?.content || null

  let translations

  try {
    translations = JSON.parse(json)
  } catch (e) {
    translations = {}
  }

  const locales = data.allLocales.edges.map(({ node }) => node).filter(({ code }) => !!code)

  const childProps = {
    t: getTranslationFunction(translations),
    p: getProjectByPath,
    locales,
    locale,
  }

  return (
    <Context.Provider value={childProps}>
      {children}
    </Context.Provider>
  )
}

TranslationInjector.propTypes = {
  locale: PropTypes.string,
  children: PropTypes.node,
}

TranslationInjector.defaultProps = {
  locale: null,
  children: null,
}

TranslationInjector = chainDecorators(decorators, TranslationInjector)

export default TranslationInjector
